import { pipe } from 'fp-ts/function';
import { array, option, string } from 'fp-ts';
import { getEntitiesExternalIdentifiersIntersection, getExternalIdentifiersGroups } from '../../../../../../utilities';
import { useAccountingCategories } from './useAccountingCategories';

interface UseCommonAccountingCategoriesKeysParams {
    enterpriseIds: string[];
}

export const useCommonAccountingCategoriesKeys = ({ enterpriseIds }: UseCommonAccountingCategoriesKeysParams) => {
    const { data: accountingCategoriesResults, isFetching } = useAccountingCategories(enterpriseIds);
    const accountingCategories = accountingCategoriesResults?.accountingCategories || [];

    if (array.isEmpty(accountingCategories)) {
        return {
            isFetching,
            data: [],
        };
    }

    const isEnterpriseIdInAccountingCategories = (enterpriseId: string) =>
        pipe(
            accountingCategories,
            option.fromNullable,
            option.map((accountingCategory) => accountingCategory.some((acc) => acc.enterpriseId === enterpriseId)),
            option.getOrElse(() => false)
        );

    if (enterpriseIds.some((enterpriseId) => !isEnterpriseIdInAccountingCategories(enterpriseId))) {
        return {
            isFetching,
            data: [],
        };
    }

    const commonAccountingCategoriesKeys = pipe(
        accountingCategories,
        getExternalIdentifiersGroups,
        getEntitiesExternalIdentifiersIntersection,
        array.sort(string.Ord)
    );

    return {
        isFetching,
        data: commonAccountingCategoriesKeys,
    };
};
